import { useMemo } from 'react';

import { useIsLongFormContentArticlePublisherEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useArticlePageNewSettings: UseMainUIFeatureSettings<'articlePageNew'> = (options) => {
  const longFormContentOverrides = options?.overrides?.articlePageNew;
  const isArticlePublisherEnabled = useIsLongFormContentArticlePublisherEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isArticlePublisherEnabled,
      ...longFormContentOverrides,
    }),
    [isArticlePublisherEnabled, longFormContentOverrides]
  );
};
